import React from 'react'

function HomeBox10() {
    return (
        <div className='homebox2main'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/img-123.png" alt="box10-img" />
                    </div>
                    <div className='homebox2-right'>
                        <div className='box10-box'>
                            <div className='box10-box-left'>
                                <span>1</span>
                            </div>
                            <div className='box10-box-right'>
                                <h5>Register in seconds</h5>
                                <p>Create your Loyalific account and explore the dashboard with a fully featured 15-day free trial — no setup required.</p>
                            </div>
                        </div>

                        <div className='box10-box'>
                            <div className='box10-box-left'>
                                <span>2</span>
                            </div>
                            <div className='box10-box-right'>
                                <h5>Design your stamp card</h5>
                                <p>Choose your industry, add your logo, colours, and rewards, and preview it in Apple and Google Wallet.</p>
                            </div>
                        </div>

                        <div className='box10-box'>
                            <div className='box10-box-left'>
                                <span>3</span>
                            </div>
                            <div className='box10-box-right'>
                                <h5>Start stamping and track results</h5>
                                <p>Share your card via QR code or link, stamp with the Stamper App, and see visits, rewards, and loyal customers in real time</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeBox10